<template>
    <div>
        <MercenaryHeader :title="'트레이닝 내역'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <InfinityScroll :is-enable-next-page-handle="isEnableNextPageHandle" :handle-next-page="handleNextPage" style="flex:1; overflow:auto;">
            <div style="padding:40px 0px; text-align:center;">
                <div style="font-size:20px; font-weight:bold;color:#210F03">트레이닝 내역</div>
                <div style="font-size:12px; font-weight:500;color:#808080; margin-top:18px;">지금까지 진행된 트레이닝 내역을 확인할 수 있습니다.</div>
            </div>

            <div v-for="each, i in join_schedules" :key="i">
                <div v-if="i === 0 || each.join_date.substr(0, 4) !== join_schedules[i - 1].join_date.substr(0, 4)" style="font-size:14px; padding:0px 10px; font-weight:500;">{{each.join_date.substr(0, 4)}}년</div>
                <div  style="display:flex; padding:20px 0px;">
                    <div style="width:60px; display:flex; justify-content: center;">
                        <img v-if="each.slider_images.length > 0" :src="$resourcePath + each.slider_images[0].thumb_image_path" style="width:40px; height:40px; border-radius:8px;">
                    </div>
                    <div style="flex:1; padding-top:3px;">
                        <div style="color:#210F03; font-weight:bold; font-size:14px;">{{each.title}}</div>
                        <div style="font-size:12px; color:#808080; font-weight:500; margin-top:3px;">
                            {{each.creator.nic_name}} 
                            <img v-if="each.creator.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" :src="require('@/assets/img/blue_star.png')" style="vertical-align:bottom;width:12px; height:12px;">
                            <img v-else :src="require('@/assets/img/yellow_star.png')" style="vertical-align:bottom;width:12px; height:12px;">
                        </div>
                        <div style="font-size:12px; font-weight:500; color:#606060;margin-top:5px; display: flex; align-items: center;flex-wrap: wrap; line-height:20px;">
                            {{$Util.getMMDDDayHangulStr(each.join_date)}} {{each.begin_time}}~{{each.end_time}}
                            <div style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: rgba(33, 15, 3, 0.698); margin:0px 5px; line-height:20px;"></div>
                            <div style="display: inline-block;  line-height:20px;">{{each.place_name}}</div>
                        </div>
                    </div>
                </div>
                <div style="padding:0px 10px;">
                    <div style="border-radius:12px; border:1px solid #D9D9D9;">
                        <div style="display:flex; padding:16px 12px;" @click="showTeamTrainingMngMember(TEAM_TRAINING_MNG_MEMBER_TYPE.APPLY, each.idx)">
                            <div style="flex:1;">
                                <div style="font-weight:500; font-size:14px; color:#210F03;">신청 회원</div>
                                <div style="font-weight:500; font-size:14px; color:#606060; margin-top:10px;">{{each.apply_member_cnt | comma}}명</div>
                            </div>
                            <div style="display:grid; place-items: center;">
                                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
                            </div>
                        </div>
                        <div style="margin:0px 12px; background-color: #D9D9D9;height:1px;"></div>
                        <div style="display:flex; padding:16px 12px;" @click="showTeamTrainingMngMember(TEAM_TRAINING_MNG_MEMBER_TYPE.CANCEL, each.idx);">
                            <div style="flex:1;">
                                <div style="font-weight:500; font-size:14px; color:#210F03;">취소 회원</div>
                                <div style="font-weight:500; font-size:14px; color:#606060; margin-top:10px;">{{each.cancel_member_cnt | comma}}명</div>
                            </div>
                            <div style="display:grid; place-items: center;">
                                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </InfinityScroll>
    </div>
</template>

<script>
    import MercenaryHeader from "../../common/MercenaryHeader";
    import {JOIN_SCHEDULE_TYPE, JOIN_STATE, TEAM_TYPE} from "../../../Constants";
    import InfinityScroll from "../../common/InfinityScroll";
    import {TEAM_TRAINING_MNG_MEMBER_TYPE} from "./TeamTrainingMngMember";

    export default {
        name: "TeamTrainingMngHistory",
        components: {InfinityScroll, MercenaryHeader},
        data(){
            return {
                TEAM_TRAINING_MNG_MEMBER_TYPE : TEAM_TRAINING_MNG_MEMBER_TYPE,
                join_schedules : [],
                page : 1,
                isEnableNextPageHandle : true,
                TEAM_TYPE: TEAM_TYPE
            }
        },
        methods : {
            async getMyTrainingClosed(){
                this.isEnableNextPageHandle = false;

                const parameters = {};
                parameters.state = JOIN_STATE.CLOSE;
                parameters.type = JOIN_SCHEDULE_TYPE.LESSON_SCHEDULE;
                parameters.is_open = '1';
                parameters.sort = 'new';
                parameters.is_with_repeat_schedule = true;
                parameters.is_with_images = true;
                parameters.is_with_creator = true;
                parameters.filter = 'made_by_me';
                parameters.is_with_member_cnt = true;
                parameters.page = this.page;

                const res = await this.$Axios.get('/api/join/schedule/list', {params : parameters});
                const join_schedules = res.data.join_schedules;

                if(join_schedules.length > 0){
                    this.isEnableNextPageHandle = true;
                    this.join_schedules = [...this.join_schedules, ...join_schedules];
                }
            },
            handleNextPage(){
                this.page++;
                this.getMyTrainingClosed();
            },
            showTeamTrainingMngMember(team_training_mng_member_type, join_schedule_idx){
                this.$GlobalStore.addModal('TeamTrainingMngMember', {team_training_mng_member_type : team_training_mng_member_type, join_schedule_idx : join_schedule_idx});
            }
        },
        created(){
            this.getMyTrainingClosed();
        }
    }
</script>

<style scoped>

</style>